import type { FC } from "react";
import { Fragment } from "react";
import { getDDMMYYYFormat, getHHmmFormat } from "../../../../../helper/dateTimeHelper";

export type DateProps = {
  value: string | number | Date | undefined | null;
}

const Date: FC<DateProps> = (props) => {
  const { value } = props;

  return (
    <Fragment>
      {getDDMMYYYFormat(value)} - {getHHmmFormat(value)}
    </Fragment>
  );
};

export default Date;
